<script setup lang="ts">
defineProps<{
    name:
        | 'home'
        | 'list'
        | 'plus'
        | 'history'
        | 'chart'
        | 'moon'
        | 'sun'
        | 'bell'
        | 'camera'
        | 'edit'
        | 'trash'
        | 'link'
        | 'check'
        | 'checkCircle'
        | 'chat'
        | 'sparkles'
        | 'sliders'
        | 'search'
        | 'mic'
        | 'square'
        | 'x'
}>()
</script>

<template>
    <svg
        class="size-5"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
    >
        <template v-if="name === 'home'">
            <path d="M3 11.5 12 4l9 7.5" />
            <path d="M5.5 10.5V20h13v-9.5" />
            <path d="M9.5 20v-5h5v5" />
        </template>

        <template v-else-if="name === 'list'">
            <path d="M8 6h13" />
            <path d="M8 12h13" />
            <path d="M8 18h13" />
            <path d="M3.5 6h.01" />
            <path d="M3.5 12h.01" />
            <path d="M3.5 18h.01" />
        </template>

        <template v-else-if="name === 'plus'">
            <path d="M12 5v14" />
            <path d="M5 12h14" />
        </template>

        <template v-else-if="name === 'history'">
            <path d="M3 12a9 9 0 1 0 3-6.7" />
            <path d="M3 4v5h5" />
            <path d="M12 7v5l3 2" />
        </template>

        <template v-else-if="name === 'chart'">
            <path d="M4 19V5" />
            <path d="M4 19h16" />
            <path d="M8 16v-5" />
            <path d="M12 16V8" />
            <path d="M16 16v-3" />
        </template>

        <template v-else-if="name === 'moon'">
            <path d="M20 14.5A8 8 0 0 1 9.5 4a7 7 0 1 0 10.5 10.5Z" />
        </template>

        <template v-else-if="name === 'sun'">
            <circle cx="12" cy="12" r="4" />
            <path d="M12 2v2" />
            <path d="M12 20v2" />
            <path d="m4.93 4.93 1.41 1.41" />
            <path d="m17.66 17.66 1.41 1.41" />
            <path d="M2 12h2" />
            <path d="M20 12h2" />
            <path d="m6.34 17.66-1.41 1.41" />
            <path d="m19.07 4.93-1.41 1.41" />
        </template>

        <template v-else-if="name === 'bell'">
            <path d="M18 9a6 6 0 0 0-12 0c0 7-3 7-3 7h18s-3 0-3-7" />
            <path d="M10 20a2 2 0 0 0 4 0" />
        </template>

        <template v-else-if="name === 'camera'">
            <path d="M4 8h3l2-3h6l2 3h3v11H4Z" />
            <circle cx="12" cy="13" r="3.5" />
        </template>

        <template v-else-if="name === 'edit'">
            <path d="M12 20h9" />
            <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L8 18l-4 1 1-4Z" />
        </template>

        <template v-else-if="name === 'trash'">
            <path d="M3 6h18" />
            <path d="M8 6V4h8v2" />
            <path d="M19 6l-1 14H6L5 6" />
            <path d="M10 11v5" />
            <path d="M14 11v5" />
        </template>

        <template v-else-if="name === 'link'">
            <path d="M10 13a5 5 0 0 0 7.07 0l2-2a5 5 0 0 0-7.07-7.07l-1.15 1.15" />
            <path d="M14 11a5 5 0 0 0-7.07 0l-2 2A5 5 0 0 0 12 20.07l1.15-1.15" />
        </template>

        <template v-else-if="name === 'check'">
            <path d="m5 12 4 4L19 6" />
        </template>

        <template v-else-if="name === 'checkCircle'">
            <circle cx="12" cy="12" r="9" />
            <path d="m8 12 3 3 5-6" />
        </template>

        <template v-else-if="name === 'chat'">
            <path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4Z" />
        </template>

        <template v-else-if="name === 'sparkles'">
            <path d="M12 3l1.8 4.2L18 9l-4.2 1.8L12 15l-1.8-4.2L6 9l4.2-1.8Z" />
            <path d="M19 15l.8 1.8L22 18l-2.2 1.2L19 21l-.8-1.8L16 18l2.2-1.2Z" />
            <path d="M5 4l.6 1.4L7 6l-1.4.6L5 8l-.6-1.4L3 6l1.4-.6Z" />
        </template>

        <template v-else-if="name === 'sliders'">
            <line x1="4" y1="6" x2="20" y2="6" />
            <line x1="4" y1="12" x2="20" y2="12" />
            <line x1="4" y1="18" x2="20" y2="18" />
            <circle cx="8" cy="6" r="2" />
            <circle cx="16" cy="12" r="2" />
            <circle cx="8" cy="18" r="2" />
        </template>

        <template v-else-if="name === 'search'">
            <circle cx="11" cy="11" r="7" />
            <path d="m20 20-3.5-3.5" />
        </template>

        <template v-else-if="name === 'mic'">
            <path d="M12 2a3 3 0 0 0-3 3v6a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z" />
            <path d="M19 10v1a7 7 0 0 1-6 6.92V20h3" />
            <path d="M5 10v1a7 7 0 0 0 6 6.92V20H8" />
        </template>

        <template v-else-if="name === 'square'">
            <rect x="6" y="6" width="12" height="12" rx="2" />
        </template>

        <template v-else-if="name === 'x'">
            <path d="M18 6 6 18" />
            <path d="m6 6 12 12" />
        </template>
    </svg>
</template>
